module.exports = "/packs/images/sprites/contact~6e8f395189312f28ceac8b85e80381d7.svg";